import React, { Component } from 'react';

import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { selectNewVehicle, selectNewVehicleValue } from '../../selectors';
import { copyVehicle } from '../../actions';

import Pusher from 'pusher-js';
import env from '../../../../env';

class PusherComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: {},
      error: null,
      newVehicleId: null,
      finish: false,
    };

    this.pusher = null;
    this.channel = null;
  }

  componentDidMount() {
    this.pusher = new Pusher(env.pusherKey, {
      cluster: 'eu',
      forceTLS: true,
    });

    this.channel = this.pusher.subscribe(this.props.roomId);

    this.channel.bind('pusher:subscription_succeeded', () => {
      if (this.props.onReady) {
        this.props.onReady();
      }
    });

    this.channel.bind('vehicle_copy_progress', data => {
      this.setState(
        {
          steps: data.steps || {},
          error: data.error,
          newVehicleId: data.newVehicleId,
          finish: data.finish,
        },
        () => {
          if (this.props.onStatusUpdate) {
            this.props.onStatusUpdate(this.state);
          }
        }
      );
    });
  }

  componentWillUnmount() {
    // Resources cleaning
    if (this.channel) {
      this.channel.unbind_all();
      this.pusher.unsubscribe(this.props.roomId);
    }
    if (this.pusher) {
      this.pusher.disconnect();
    }
  }

  render() {
    return null; // This component doesn't need to render anything
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    creditorCompany: selectNewVehicleValue('creditor_company'),
    creditor: selectNewVehicleValue('creditor'),
    values: selectNewVehicle(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    copyVehicle(dto, callback) {
      dispatch(copyVehicle(ownProps.vehicle.id, dto, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const PusherChannel = compose(withConnect, withRouter)(PusherComp);
